<!-- هدر -->

<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> خوشه بندی هوشمند </span>

    </div>

</div>

<main class="p-2 w-100">

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-md-0 gy-2">

            <!-- فیلتر جستجو -->

            <div class="col-md-9 col-12">

                <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

            <!-- تعیین خودرو -->

            <div class="col-md-auto col-12 px-md-1 px-0">

                <button class="btn btn-primary w-100" (click)="assign_Modal()">
                    
                    تعیین خودرو
                    
                </button>

            </div>

            <!-- خروجی اکسل -->

            <div class="col-md-auto col-12 px-md-1 px-0">

                <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')">
                    
                    خروجی اکسل
                    
                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 170px);overflow: auto;">

            <table class="col-12 table  rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center pointer"> # </th>

                        <th class="text-center pointer" (click)="markAll()"> انتخاب </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> خوشه </th>

                        <th class="text-center"> نام و نام خانوادگی  </th>

                        <th class="text-center"> جنسیت </th>

                        <th class="text-center"> مدرسه </th>

                        <th class="text-center"> راننده </th>

                        <th class="text-center"> آدرس </th>

                        <th class="text-center"> پلاک خودرو </th>

                        <th class="text-center"> DCC(m) </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" 

                        [ngStyle]="{ 'background-color': getRowColor(item.ClusterId) }" 
                    
                        *ngFor="let item of lst_Request;let i = index">

                        <td>{{ i + 1 | faNum }}</td>

                        <td> 
                            
                            <input class="pointer" type="checkbox" 

                                (change)="markSchedule($event.target.checked,item)"
                            
                                [checked]="isSelected(item.iPassenger)"> 
                        
                        </td>

                        <th class=""> 

                            <i class="fa fa-info-circle mx-2 fa-lg pointer" aria-hidden="true" (click)="open_Detail(item)"></i>

                            <i class="fa fa-map-marker mx-2 fa-lg pointer" aria-hidden="true" (click)="open_Location(item)"></i>
                            
                        </th>

                        <td> {{ item.ClusterId }} </td>

                        <td> {{ item.strPassenger_FullName }} </td>

                        <td> {{ item.strSex_strSexComment }} </td>

                        <td> {{ item.strMobileDomain_strComment }} </td>

                        <td> {{ item.strDriver_strFullName }} </td>

                        <td class=""> 
                            
                            <p style="width: 300px;text-wrap: initial;"> 
                            
                                {{ item.strAddress }} 
                        
                            </p> 
                    
                        </td>

                        <td> {{ item.strVehicleNo }} </td>

                        <td> {{ item.ClusterDistance | number:'1.0-0' }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

    <!-- مدال تعیین خودرو -->

    <div class="modal fade" id="detailModal" tabindex="-1" data-backdrop="false" data-keyboard="false">

        <div class="modal-dialog modal-dialog-centered modal-lg">

            <div class="modal-content p-1">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title"> تعیین راننده </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
                
                <div class="modal-body">

                    <input placeholder="نام راننده را جستجو کنید"  autocomplete="off" class="form-control mb-1 no-x"  (input)="filterDriver($event.target)" />
        
                    <ul class="list-group" style="max-height: 400px;overflow: auto;">
                    
                      <li class="list-group-item pointer d-flex align-items-center"  *ngFor="let item of list_Drivers" (click)="selectedDriver(item)" > 
                        
                          {{ 'نام راننده : ' + item.strFullName  | faNum }} <br> {{ ' نوع خودرو : ' + item.strMobileType_strComment   | faNum }} <br>

                          {{'تعداد دانش آموز پسر : ' + item.iStudent_Boy | faNum }}  <br>  {{'تعداد دانش آموز دختر : ' + item.iStudent_Girl | faNum }}
                        
                      </li>
              
                    </ul>


                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
    
                        &nbsp; بستن &nbsp;
    
                    </button>
    
                </div>

            </div>

        </div>

    </div>

    <!-- نمایش موقعیت دانش آموز -->

    <custom-map *ngIf="showCustom_Map"

        [strValue]="mdl_Map.get('strAddress')?.value"

        [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

        [isOpenModal]="true"

        [isView]="true"

        [skip_Search]="true"

        (mdl_Submit)="showCustom_Map=false">

    </custom-map>

    <!-- مدال اطلاعات دانش آموز -->

    <div class="modal fade" id="studentModal" style="z-index: 100000000000000;" tabindex="-1" data-backdrop="false" data-keyboard="false">

        <div class="modal-dialog modal-dialog-centered modal-lg">
    
            <div class="modal-content p-1">
    
                <div class="modal-header dirI">
    
                    <h5 class="modal-title"> جزئیات دانش آموز </h5>
    
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    
                </div>
    
                <div dir="rtl" class="row justify-content-center align-items-center p-2 gx-2 gy-2">
    
                    <div class="col-12 text-center col-md-3">
    
                        <img class="rounded-circle" 
                    
                            width="150" height="150"
    
                            src="{{studentData?.strAvatar != '' ? 'data:image/jpeg;base64,' +  studentData?.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
    
                            alt="تصویر دانش آموز">
    
                    </div>
    
                    <div class="col-12 col-md-9 row gx-2 gy-2">
    
                        <div class="col-12 col-md-4">
    
                            <label>نام</label>
        
                            <input type="text" [ngModel]="studentData?.strName" class="form-control">
        
                        </div>
        
                        <div class="col-12 col-md-4">
        
                            <label>نام خانوادگی</label>
        
                            <input type="text" [ngModel]="studentData?.strFamily" class="form-control">
        
                        </div>
        
                        <div class="col-12 col-md-4">
        
                            <label>پایه</label>
        
                            <input type="text" [ngModel]="studentData?.strGrade" class="form-control">
        
                        </div>
        
                        <div class="col-12 col-md-4">
        
                            <label>کلاس</label>
        
                            <input type="text" [ngModel]="studentData?.strClassNo_strTitle" class="form-control">
        
                        </div>
        
                        <div class="col-12 col-md-4">
        
                            <label>جنسیت</label>
        
                            <input type="text" [ngModel]="studentData?.strSex_strSexComment" class="form-control">
        
                        </div>
        
                        <div class="col-12 col-md-4">
        
                            <label>شماره موبایل</label>
        
                            <input dir="ltr" type="text" [ngModel]="( studentData?.strMobile | faNum )" class="form-control">
        
                        </div>
        
                        <div class="col-12 col-md-4">
        
                            <label> کد ملی </label>
        
                            <input dir="ltr" type="text" [ngModel]="( studentData?.strNationalCode | faNum)"
                                class="form-control">
        
                        </div>
    
                        <div class="col-12 col-md-4">
        
                            <label> مدرسه </label>
        
                            <input type="text" [ngModel]="studentData?.strMobileDomain_strComment" class="form-control">
        
                        </div>
        
                        <div class="col-12 col-md-4">
        
                            <label> نام راننده </label>
        
                            <input type="text" [ngModel]="studentData?.strFullName" class="form-control text-danger">
        
                        </div>
        
                        <div class="col-12">
        
                            <label> آدرس </label>
        
                            <input type="text" [ngModel]="studentData?.strAddress" class="form-control">
        
                        </div>
    
                    </div>
    
                </div>
    
            </div>
    
        </div>
    
    </div>

</main>